$(document).ready(function(){
    $(".partner-slide").slick({
        dots: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: true,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    function pViewDescription() {
        var partnerHeader = $('.headerPartner');
        var partnerViewDescription = $('#partnerViewDescription').offset();
        var postContent = $('.articleContainer .rightContainer').offset();

        var scrollRef;
        if (partnerViewDescription) {
            scrollRef = partnerViewDescription;
        }
        else if (postContent) {
            scrollRef = postContent
        }

        if (scrollRef) {
            if (scrollRef.top < (partnerHeader.offset().top + partnerHeader.outerHeight()) ) {
                $('.headerPartner .postsocialheader').show();
                $('.headerPartner .sectionName').hide();
                $('.headerPartner .logoTitleHpartner').show();
                $('#headerPartnerLogo').empty();
                $('#headerPartnerLogo').append($('#partnerViewLogo').clone());
                $('#headerPartnerTitle').empty();
                var parentLink = $("<a></a>").html($('#partnerViewTitle').html())
                                            .attr("href", $('#partnerParentUrl').html());
                $('#headerPartnerTitle').append(parentLink);
                if ($('#partnerPostTitle').html()) {
                    var postTitle = $("<span></span>").html($('#partnerPostTitle').html());
                    $('#headerPartnerTitle').append(postTitle);
                }
            }
            else
            {
                $('.headerPartner .postsocialheader').hide();
                $('.headerPartner .sectionName').show();
                $('.headerPartner .logoTitleHpartner').hide();
                $('#headerPartnerLogo').empty();
                $('#headerPartnerTitle').empty();
            }
        }
    }
    
    $(window).scroll(pViewDescription);

    pViewDescription();
});

